import React from "react";
import Layout from "../components/Layout";
import DemoForm from "../components/DemoForm";

function Demo() {
  return (
    <Layout>
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="mb-3">Book a Demo</h1>
          <p className="lead">
            Experience WebVenly firsthand. We'll walk you through the platform,
            answer your questions, and show you how it can simplify your service
            delivery.
          </p>
        </div>

        {/* Detailed Benefits Section */}
        <div className="row g-4 mb-5">
          {/* What You’ll See */}
          <div className="col-md-6">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">✅ What You’ll See in the Demo</h5>
                <ul className="list-unstyled mt-3 mb-0 fs-6">
                  <li className="mb-2">
                    ✔️ Logging hours, notes, and mileage for services
                  </li>
                  <li className="mb-2">
                    ✔️ Generating PDF reports and invoice supporting
                    documentation
                  </li>
                  <li className="mb-2">
                    ✔️ Capturing digital signatures from job coaches and clients
                  </li>
                  <li className="mb-2">
                    ✔️ Managing consumers, authorizations, and plans
                  </li>
                  <li className="mb-2">
                    ✔️ Monitoring activity and assigning roles as an
                    administrator
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Who Should Attend */}
          <div className="col-md-6">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">👥 Who Should Attend</h5>
                <ul className="list-unstyled mt-3 mb-0 fs-6">
                  <li className="mb-2">🧑‍💼 CRP Administrators & Directors</li>
                  <li className="mb-2">🧑‍🏫 Job Coaches and Field Staff</li>
                  <li className="mb-2">🏢 Partner</li>
                  <li className="mb-2">
                    🎯 Anyone evaluating tools for workforce services
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="mb-5">
          <h4>Request Your Personalized Demo:</h4>
          <p className="text-muted mb-4">
            Fill out the form below and someone from our team will follow up
            within one business day. We’ll tailor the walkthrough to your
            specific needs and role.
          </p>
          <DemoForm />
        </div>

        {/* Final CTA */}
        <div className="text-center mt-5">
          <p className="lead">
            Whether you're just exploring or ready to switch, we're here to
            help.
          </p>
          <p>
            Let us show you how WebVenly saves time, improves reporting, and
            empowers your team.
          </p>
        </div>
      </div>
    </Layout>
  );
}

export default Demo;
